export default __webpack_public_path__ + "static/media/user.50050d72.jpg";